module.exports = __webpack_public_path__ + "static/media/LogicWheel1_1_3.7dc2965a.png";